import React, { useEffect } from 'react';
import Header from '@components/Comman/Header';
import { Tabs } from 'antd';
import RaiseTicket from './RaiseTicket';
import { getAllAdminNotificationCount, updateReferrerNotificationCount } from '../../actions/refer';
import { useDispatch, useSelector } from 'react-redux';

const ContactUs = () => {

    const dispatch = useDispatch();
    const userData = useSelector((state: any) => state?.Auth?.user);
    const userRoleId = userData?.data?.roleId;

    useEffect(()=> {
        dispatch(updateReferrerNotificationCount({resetType: 'contact', role: userRoleId }, (res:any)=>{
            dispatch(getAllAdminNotificationCount({}, (res:any)=>{}))
        }))
    }, [])


    return (
        <div>
            <Header pagTitle="Contact Us" />
            <div className="contentBody">
                <div className="bodycard">
                    {/* <div className="bodycardheading">Contact Us</div> */}
                    <div className="cardContentbody">
                        <Tabs defaultActiveKey="1">
                            <Tabs.TabPane tab="Contact List" key="1">
                                <RaiseTicket type="contact" />
                            </Tabs.TabPane>
                            <Tabs.TabPane tab="Tickets" key="2">
                                <RaiseTicket type="ticket" />
                            </Tabs.TabPane>
                            <Tabs.TabPane tab="API Integration" key="3" >
                                <RaiseTicket type="contact" contactType="apiIntegration" />
                            </Tabs.TabPane>
                        </Tabs>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;
